module.exports = __webpack_public_path__ + "notifications.96ea78aee27529ffcca04b27e950f0e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/notifications.svg
// module id = 341
// module chunks = 0